module.exports = __webpack_public_path__ + "img/free.3073e134.png";